const ITEM_STATUS = {
  REQUESTED: 'REQUESTED',
  ASSIGNED: 'ASSIGNED',
  RESPONDED: 'RESPONDED',
  CONCLUDED: 'CONCLUDED'
}

export { ITEM_STATUS }
